import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const nganSachMenu: NavMenu = {
  title: 'Ngân sách',
  items: [
    {
      title: 'Danh mục chỉ tiêu ngân sách',
      icon: <AritoIcon icon={236} />,
      href: '/ngan-sach/danh-muc-chi-tieu-ngan-sach'
    },
    {
      title: 'Cập nhật dự toán ngân sách',
      icon: <AritoIcon icon={767} />,
      href: '/ngan-sach/cap-nhat-du-toan-ngan-sach'
    },
    {
      title: 'Báo cáo ngân sách',
      icon: <AritoIcon icon={231} />,
      href: '/ngan-sach/bao-cao-ngan-sach'
    },
    {
      title: 'Báo cáo ngân sách nhiều kỳ',
      icon: <AritoIcon icon={789} />,
      href: '/ngan-sach/bao-cao-ngan-sach-nhieu-ky'
    }
  ]
};
